import { Fragment, forwardRef } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Slide,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface Props {
  title: string;
  message: string;
  open: boolean;
  onClose: () => void;
  response: (value: boolean) => void;
}

export default function MDDialog({
  title,
  message,
  open,
  onClose,
  response,
}: Props): JSX.Element {
  return (
    <Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{title}</DialogTitle>
        <Divider sx={{ m: 0 }} />
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => response(false)}>Cancelar</Button>
          <Button onClick={() => response(true)}>OK</Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
